module.exports = __webpack_public_path__ + "static/media/bg.253a1737.png";